import React, {useEffect} from 'react';
  import {useApi} from "../../../providers/ApiProvider";
  import BusinessesPostsModel from "../../../models/BusinessesPostsModel";
  import BusinessesModel from "../../../models/BusinessesModel";
  import {useParams, Link} from "react-router-dom";
  import {useBreadcrumbs} from "../../../providers/BreadcrumbsProvider";
  import BusinessViewHeader from "../BusinessViewHeader";
  import BusinessViewMenu from "../BusinessViewMenu";
  import {useTranslation} from "react-i18next";
  import {useTranslation as useMyTranslation} from "../../../providers/TranslationProvider";

  function BusinessesPostCalendar() {
      const {language} = useMyTranslation();
      const {t} = useTranslation();
      const params = useParams();
      const apiContext = useApi();
      const bpModel = new BusinessesPostsModel(apiContext.api);
      const businessesModel = new BusinessesModel(apiContext.api);
      const breadcrumbs = useBreadcrumbs();

      const [posts, setPosts] = React.useState([]);
      const [loading, setLoading] = React.useState(true);
      const [currentDate, setCurrentDate] = React.useState(new Date());
      const [draggedPost, setDraggedPost] = React.useState(null);

      useEffect(function() {
          businessesModel.view(params.locationId).then(function(response) {
              if (response !== false) {
                  breadcrumbs.update({
                      title: response.data.title,
                      breadcrumbs: [
                          {label: t('Businesses List'), url: '/businesses'},
                          {label: response.data.title, url: '/businesses/' + params.locationId},
                          {label: t('Post-Kalender')}
                      ]
                  });
                  document.title = t('Post-Kalender') + ' | ' + response.data.title + ' | LocalBoost';
              }
          });
          loadPosts();
      }, [language]);

      var loadPosts = function() {
          setLoading(true);
          bpModel.list(params.locationId).then(function(response) {
              if (response !== false && Array.isArray(response)) {
                  setPosts(response);
              }
          }).finally(function() { setLoading(false); });
      };

      var year = currentDate.getFullYear();
      var month = currentDate.getMonth();

      var firstDay = new Date(year, month, 1);
      var lastDay = new Date(year, month + 1, 0);
      var startWeekday = (firstDay.getDay() + 6) % 7;
      var daysInMonth = lastDay.getDate();

      var prevMonth = function() { setCurrentDate(new Date(year, month - 1, 1)); };
      var nextMonth = function() { setCurrentDate(new Date(year, month + 1, 1)); };
      var goToday = function() { setCurrentDate(new Date()); };

      var monthName = currentDate.toLocaleDateString('de-DE', {month: 'long', year: 'numeric'});
      var weekDays = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

      var getPostsForDay = function(day) {
          return posts.filter(function(p) {
              if (!p.publish_time) return false;
              var d = new Date(p.publish_time);
              return d.getFullYear() === year && d.getMonth() === month && d.getDate() === day;
          });
      };

      var getPostTitle = function(post) {
          if (post.data && post.data.summary) {
              return post.data.summary.substring(0, 40) + (post.data.summary.length > 40 ? '...' : '');
          }
          return t('Beitrag');
      };

      var getPostTypeIcon = function(post) {
          var topicType = (post.data && post.data.topicType) || '';
          if (topicType === 'EVENT') return 'ti-calendar-event';
          if (topicType === 'OFFER') return 'ti-tag';
          return 'ti-article';
      };

      var onDragStart = function(e, post) {
          setDraggedPost(post);
          e.dataTransfer.effectAllowed = 'move';
      };

      var onDragOver = function(e) {
          e.preventDefault();
          e.dataTransfer.dropEffect = 'move';
      };

      var onDrop = function(e, day) {
          e.preventDefault();
          if (!draggedPost) return;
          var newDate = new Date(year, month, day, 12, 0, 0);
          var isoDate = newDate.toISOString().slice(0, 19).replace('T', ' ');
          bpModel.reschedule(params.locationId, draggedPost.id, isoDate).then(function(response) {
              if (response !== false) {
                  loadPosts();
              }
          });
          setDraggedPost(null);
      };

      var today = new Date();
      var isToday = function(day) {
          return today.getFullYear() === year && today.getMonth() === month && today.getDate() === day;
      };

      var cells = [];
      var i;
      for (i = 0; i < startWeekday; i++) {
          cells.push(React.createElement('td', {key: 'empty-' + i, className: 'bg-light', style: {height: '100px', verticalAlign: 'top'}}));
      }
      for (var day = 1; day <= daysInMonth; day++) {
          (function(d) {
              var dayPosts = getPostsForDay(d);
              var todayClass = isToday(d) ? ' bg-light-primary' : '';
              cells.push(
                  React.createElement('td', {
                      key: 'day-' + d,
                      className: 'p-1' + todayClass,
                      style: {height: '100px', verticalAlign: 'top', cursor: 'default'},
                      onDragOver: onDragOver,
                      onDrop: function(e) { onDrop(e, d); }
                  },
                      React.createElement('div', {className: 'd-flex justify-content-between align-items-start px-1'},
                          React.createElement('span', {className: 'fw-semibold fs-3' + (isToday(d) ? ' text-primary' : ' text-muted')}, d)
                      ),
                      React.createElement('div', {className: 'mt-1', style: {maxHeight: '70px', overflowY: 'auto'}},
                          dayPosts.map(function(post, idx) {
                              return React.createElement(Link, {
                                  key: post.id || idx,
                                  to: '/businesses/' + params.locationId + '/publications/' + post.id,
                                  className: 'd-block text-decoration-none rounded px-1 py-0 mb-1 fs-1 text-truncate ' + (post.status === 'PUBLISHED' ? 'bg-light-success text-success' : 'bg-light-warning text-warning'),
                                  draggable: post.status !== 'PUBLISHED',
                                  onDragStart: function(e) { onDragStart(e, post); },
                                  style: {cursor: post.status !== 'PUBLISHED' ? 'grab' : 'pointer'}
                              },
                                  React.createElement('i', {className: 'ti ' + getPostTypeIcon(post) + ' me-1'}),
                                  getPostTitle(post)
                              );
                          })
                      )
                  )
              );
          })(day);
      }

      var rows = [];
      for (i = 0; i < cells.length; i += 7) {
          rows.push(React.createElement('tr', {key: 'row-' + i}, cells.slice(i, i + 7)));
      }
      var lastRowLen = cells.length % 7;
      if (lastRowLen > 0) {
          var trailing = [];
          for (i = 0; i < 7 - lastRowLen; i++) {
              trailing.push(React.createElement('td', {key: 'trail-' + i, className: 'bg-light', style: {height: '100px'}}));
          }
          var lastIdx = rows.length - 1;
          var lastCells = cells.slice(lastIdx * 7);
          rows[lastIdx] = React.createElement('tr', {key: 'row-last'}, lastCells.concat(trailing));
      }

      return React.createElement(React.Fragment, null,
          React.createElement(BusinessViewHeader, {locationId: params.locationId, onProfileRefresh: function() {}}),
          React.createElement(BusinessViewMenu, {locationId: params.locationId, active: 'publications'}),
          React.createElement('div', {className: 'card rounded-2 mt-3'},
              React.createElement('div', {className: 'card-body p-3'},
                  React.createElement('div', {className: 'd-flex justify-content-between align-items-center mb-3'},
                      React.createElement('div', {className: 'd-flex align-items-center gap-2'},
                          React.createElement('button', {className: 'btn btn-sm btn-outline-primary', onClick: prevMonth}, React.createElement('i', {className: 'ti ti-chevron-left'})),
                          React.createElement('button', {className: 'btn btn-sm btn-outline-primary', onClick: goToday}, t('Heute')),
                          React.createElement('button', {className: 'btn btn-sm btn-outline-primary', onClick: nextMonth}, React.createElement('i', {className: 'ti ti-chevron-right'})),
                          React.createElement('h5', {className: 'mb-0 ms-2 text-capitalize'}, monthName)
                      ),
                      React.createElement('div', {className: 'd-flex align-items-center gap-2'},
                          React.createElement(Link, {to: '/businesses/' + params.locationId + '/publications', className: 'btn btn-sm btn-outline-secondary'},
                              React.createElement('i', {className: 'ti ti-list me-1'}), t('Listenansicht')
                          ),
                          React.createElement(Link, {to: '/businesses/' + params.locationId + '/publications/create', className: 'btn btn-sm btn-primary'},
                              React.createElement('i', {className: 'ti ti-plus me-1'}), t('New Post')
                          )
                      )
                  ),
                  React.createElement('div', {className: 'd-flex gap-3 mb-2 fs-2'},
                      React.createElement('span', null, React.createElement('span', {className: 'd-inline-block rounded px-2 bg-light-success text-success me-1'}, '\u25A0'), t('Ver\u00f6ffentlicht')),
                      React.createElement('span', null, React.createElement('span', {className: 'd-inline-block rounded px-2 bg-light-warning text-warning me-1'}, '\u25A0'), t('Entwurf'))
                  ),
                  loading
                      ? React.createElement('div', {className: 'text-center py-5'}, React.createElement('div', {className: 'spinner-border text-primary', role: 'status'}))
                      : React.createElement('div', {className: 'table-responsive'},
                          React.createElement('table', {className: 'table table-bordered mb-0', style: {tableLayout: 'fixed'}},
                              React.createElement('thead', null,
                                  React.createElement('tr', null, weekDays.map(function(d) { return React.createElement('th', {key: d, className: 'text-center bg-light py-2 fs-3'}, d); }))
                              ),
                              React.createElement('tbody', null, rows)
                          )
                      ),
                  React.createElement('p', {className: 'text-muted fs-2 mt-2'},
                      React.createElement('i', {className: 'ti ti-arrows-move me-1'}),
                      t('Entw\u00fcrfe per Drag & Drop auf ein anderes Datum verschieben')
                  )
              )
          )
      );
  }

  export default BusinessesPostCalendar;
  